// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Map from './components/Map';
import Contact from './components/Contact';
import AdBanner from './components/AdBanner';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Ana sayfa */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <About />
              <AdBanner />
              <Services />
              <AdBanner />
              <Map />
              <Contact />
            </>
          }
        />

        {/* Hizmetler */}
        <Route
          path="/hizmetler"
          element={
            <>
              <Services />
            </>
          }
        />

        {/* Hakkımızda */}
        <Route
          path="/hakkimizda"
          element={
            <>
              <About />
            </>
          }
        />

        {/* İletişim */}
        <Route
          path="/iletisim"
          element={
            <>
              <Contact />
              <Map />
            </>
          }
        />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
